import { ClosingOnlineItemController } from "./closing-item.controller";
import "./item-bids-dialog/item-bids-trigger.component";

angular
    .module("thor.online-containers.edit.closing-item.component", [
        "thor.online-containers.edit.item-bids-trigger.component"
    ])
    .component("closingOnlineItem", {
        bindings: {
            item: "<",
            saleCurrency: "<",
            selectedLang: "<"
        },
        controller: ClosingOnlineItemController,
        template: require("./closing-item.html")
    });
